// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_jlpt_levels_n2_description = /** @type {(inputs: {}) => string} */ () => {
	return `Get comfortable with real-world Japanese! Read news articles, understand business conversations, and use nuanced grammar.`
};

const id_jlpt_levels_n2_description = /** @type {(inputs: {}) => string} */ () => {
	return `Biasakan diri dengan bahasa Jepang di dunia nyata! Baca artikel berita, pahami percakapan bisnis, dan gunakan tata bahasa yang bernuansa.`
};

const ja_jlpt_levels_n2_description = /** @type {(inputs: {}) => string} */ () => {
	return `実践的な日本語を身につけましょう！ニュース記事を読んだり、ビジネス会話を理解したり、ニュアンスのある文法を使いこなしたり。`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "id" | "ja" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const jlpt_levels_n2_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jlpt_levels_n2_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("jlpt_levels_n2_description", locale)
	if (locale === "en") return en_jlpt_levels_n2_description(inputs)
	if (locale === "id") return id_jlpt_levels_n2_description(inputs)
	return ja_jlpt_levels_n2_description(inputs)
};
export { jlpt_levels_n2_description as "jlpt_levels.n2.description" }